const services = [
  {
    icon: 'ri-home-heart-line',
    title: 'Home Buyer Inspections',
    description:
      'A comprehensive inspection before closing gives you the full picture. We examine every accessible area of the home so you can negotiate confidently or walk away informed.',
    highlight: true,
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Pre-Listing Inspections',
    description:
      'Sellers benefit from knowing the condition of their home before it hits the market. Identify and address issues proactively for a smoother, faster sale.',
    highlight: false,
  },
  {
    icon: 'ri-search-eye-line',
    title: 'General Home Condition Inspections',
    description:
      'Ideal for current homeowners who want peace of mind. Get a clear snapshot of your home&apos;s condition and catch maintenance issues before they become costly problems.',
    highlight: false,
  },
  {
    icon: 'ri-file-text-line',
    title: 'Detailed Findings & Reports',
    description:
      'Every inspection includes a clear, easy-to-read report delivered promptly after the visit. No jargon &mdash; just straightforward findings and actionable information.',
    highlight: false,
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Flexible Scheduling',
    description:
      'We work around your schedule. Whether you need a quick turnaround or a weekend appointment, we&apos;ll do our best to accommodate your timeline.',
    highlight: false,
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-surface">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block w-8 h-0.5 bg-accent"></span>
            <span className="text-accent font-semibold text-sm tracking-widest uppercase">What We Offer</span>
            <span className="block w-8 h-0.5 bg-accent"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy leading-tight mb-4">
            Inspection Services
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Straightforward services designed to help buyers, sellers, and homeowners make informed decisions about their properties in Northern Michigan.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className={`rounded-lg p-6 flex flex-col gap-4 transition-all duration-200 cursor-default ${
                service.highlight
                  ? 'bg-navy text-white'
                  : 'bg-white border border-gray-100 hover:border-accent/30'
              }`}
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-md flex-shrink-0 ${
                  service.highlight ? 'bg-white/10' : 'bg-accent-muted'
                }`}
              >
                <i
                  className={`${service.icon} text-2xl ${
                    service.highlight ? 'text-accent-light' : 'text-accent'
                  }`}
                ></i>
              </div>
              <div>
                <h3
                  className={`font-heading font-semibold text-lg mb-2 ${
                    service.highlight ? 'text-white' : 'text-navy'
                  }`}
                >
                  {service.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed ${
                    service.highlight ? 'text-white/75' : 'text-gray-500'
                  }`}
                  dangerouslySetInnerHTML={{ __html: service.description }}
                />
              </div>
              {service.highlight && (
                <div className="mt-auto pt-2">
                  <span className="inline-block bg-accent-light/20 text-accent-light text-xs font-semibold px-3 py-1 rounded-full">
                    Most Popular
                  </span>
                </div>
              )}
            </div>
          ))}

          {/* CTA Card */}
          <div className="sm:col-span-2 lg:col-span-1 rounded-lg p-6 bg-accent-muted border border-accent/20 flex flex-col items-start justify-between gap-4">
            <div>
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent/10 mb-4">
                <i className="ri-question-line text-2xl text-accent"></i>
              </div>
              <h3 className="font-heading font-semibold text-lg text-navy mb-2">Not Sure What You Need?</h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                Every situation is a little different. Reach out and we&apos;ll help you figure out which inspection is right for your goals.
              </p>
            </div>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent text-white text-sm font-semibold rounded-md cursor-pointer hover:bg-accent-light transition-colors whitespace-nowrap"
            >
              Get in Touch
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
